const data = [
    {
        id:1,
        image:'https://img.freepik.com/free-photo/exploding-burger-with-vegetables-melted-cheese-black-background-generative-ai_157027-1734.jpg?w=1480&t=st=1695248672~exp=1695249272~hmac=b7742b67814879a0a4038254eb11538a2310a6c5e0c653ea569cfc6f65ed6149',
        tag:'burger'
    },
    {
        id:2,
        image:'https://img.freepik.com/free-photo/exploding-burger-with-vegetables-melted-cheese-black-background-generative-ai_157027-1734.jpg?w=1480&t=st=1695248672~exp=1695249272~hmac=b7742b67814879a0a4038254eb11538a2310a6c5e0c653ea569cfc6f65ed6149',
        tag:'burger'
    },
    {
        id:3,
        image:'https://img.freepik.com/free-photo/exploding-burger-with-vegetables-melted-cheese-black-background-generative-ai_157027-1734.jpg?w=1480&t=st=1695248672~exp=1695249272~hmac=b7742b67814879a0a4038254eb11538a2310a6c5e0c653ea569cfc6f65ed6149',
        tag:'burger'
    },
    {
        id:4,
        image:'https://img.freepik.com/free-photo/exploding-burger-with-vegetables-melted-cheese-black-background-generative-ai_157027-1734.jpg?w=1480&t=st=1695248672~exp=1695249272~hmac=b7742b67814879a0a4038254eb11538a2310a6c5e0c653ea569cfc6f65ed6149',
        tag:'burger'
    },
    {
        id:5,
        image:'https://img.freepik.com/free-photo/exploding-burger-with-vegetables-melted-cheese-black-background-generative-ai_157027-1734.jpg?w=1480&t=st=1695248672~exp=1695249272~hmac=b7742b67814879a0a4038254eb11538a2310a6c5e0c653ea569cfc6f65ed6149',
        tag:'burger'
    },
    {
        id:6,
        image:'https://img.freepik.com/free-photo/exploding-burger-with-vegetables-melted-cheese-black-background-generative-ai_157027-1734.jpg?w=1480&t=st=1695248672~exp=1695249272~hmac=b7742b67814879a0a4038254eb11538a2310a6c5e0c653ea569cfc6f65ed6149',
        tag:'burger'
    },
    {
        id:7,
        image:'https://img.freepik.com/free-photo/exploding-burger-with-vegetables-melted-cheese-black-background-generative-ai_157027-1734.jpg?w=1480&t=st=1695248672~exp=1695249272~hmac=b7742b67814879a0a4038254eb11538a2310a6c5e0c653ea569cfc6f65ed6149',
        tag:'burger'
    },
    {
        id:8,
        image:'https://img.freepik.com/free-photo/grill-with-variety-meats-it_188544-8372.jpg?w=1380&t=st=1695228247~exp=1695228847~hmac=d7bb5251ad3573c0e7d3c08f4b3db66103916e76a389e5fd2a0d96df308e6df1',
        tag:'bbq'
    },
    {
        id:9,
        image:'https://img.freepik.com/free-photo/grill-with-variety-meats-it_188544-8372.jpg?w=1380&t=st=1695228247~exp=1695228847~hmac=d7bb5251ad3573c0e7d3c08f4b3db66103916e76a389e5fd2a0d96df308e6df1',
        tag:'bbq'
    },
    {
        id:10,
        image:'https://img.freepik.com/free-photo/grill-with-variety-meats-it_188544-8372.jpg?w=1380&t=st=1695228247~exp=1695228847~hmac=d7bb5251ad3573c0e7d3c08f4b3db66103916e76a389e5fd2a0d96df308e6df1',
        tag:'bbq'
    },
    {
        id:11,
        image:'https://img.freepik.com/free-photo/grill-with-variety-meats-it_188544-8372.jpg?w=1380&t=st=1695228247~exp=1695228847~hmac=d7bb5251ad3573c0e7d3c08f4b3db66103916e76a389e5fd2a0d96df308e6df1',
        tag:'bbq'
    },
    {
        id:12,
        image:'https://img.freepik.com/free-photo/grill-with-variety-meats-it_188544-8372.jpg?w=1380&t=st=1695228247~exp=1695228847~hmac=d7bb5251ad3573c0e7d3c08f4b3db66103916e76a389e5fd2a0d96df308e6df1',
        tag:'bbq'
    },
    {
        id:13,
        image:'https://img.freepik.com/free-photo/grill-with-variety-meats-it_188544-8372.jpg?w=1380&t=st=1695228247~exp=1695228847~hmac=d7bb5251ad3573c0e7d3c08f4b3db66103916e76a389e5fd2a0d96df308e6df1',
        tag:'bbq'
    },
    {
        id:14,
        image:'https://img.freepik.com/free-photo/grill-with-variety-meats-it_188544-8372.jpg?w=1380&t=st=1695228247~exp=1695228847~hmac=d7bb5251ad3573c0e7d3c08f4b3db66103916e76a389e5fd2a0d96df308e6df1',
        tag:'bbq'
    },
    {
        id:15,
        image:'https://img.freepik.com/free-photo/freshly-italian-pizza-with-mozzarella-cheese-slice-generative-ai_188544-12347.jpg?w=1480&t=st=1695227112~exp=1695227712~hmac=a01daadfb8a02251c962e0377db5d31ee4dcaa1650b62c38dfe0a432b872dfa3',
        tag:'pizza'
    },
    {
        id:16,
        image:'https://img.freepik.com/free-photo/freshly-italian-pizza-with-mozzarella-cheese-slice-generative-ai_188544-12347.jpg?w=1480&t=st=1695227112~exp=1695227712~hmac=a01daadfb8a02251c962e0377db5d31ee4dcaa1650b62c38dfe0a432b872dfa3',
        tag:'pizza'
    },
    {
        id:17,
        image:'https://img.freepik.com/free-photo/freshly-italian-pizza-with-mozzarella-cheese-slice-generative-ai_188544-12347.jpg?w=1480&t=st=1695227112~exp=1695227712~hmac=a01daadfb8a02251c962e0377db5d31ee4dcaa1650b62c38dfe0a432b872dfa3',
        tag:'pizza'
    },
    {
        id:18,
        image:'https://img.freepik.com/free-photo/freshly-italian-pizza-with-mozzarella-cheese-slice-generative-ai_188544-12347.jpg?w=1480&t=st=1695227112~exp=1695227712~hmac=a01daadfb8a02251c962e0377db5d31ee4dcaa1650b62c38dfe0a432b872dfa3',
        tag:'pizza'
    },
    {
        id:19,
        image:'https://img.freepik.com/free-photo/freshly-italian-pizza-with-mozzarella-cheese-slice-generative-ai_188544-12347.jpg?w=1480&t=st=1695227112~exp=1695227712~hmac=a01daadfb8a02251c962e0377db5d31ee4dcaa1650b62c38dfe0a432b872dfa3',
        tag:'pizza'
    },
    {
        id:20,
        image:'https://img.freepik.com/free-photo/freshly-italian-pizza-with-mozzarella-cheese-slice-generative-ai_188544-12347.jpg?w=1480&t=st=1695227112~exp=1695227712~hmac=a01daadfb8a02251c962e0377db5d31ee4dcaa1650b62c38dfe0a432b872dfa3',
        tag:'pizza'
    },
    {
        id:21,
        image:'https://img.freepik.com/free-photo/freshly-italian-pizza-with-mozzarella-cheese-slice-generative-ai_188544-12347.jpg?w=1480&t=st=1695227112~exp=1695227712~hmac=a01daadfb8a02251c962e0377db5d31ee4dcaa1650b62c38dfe0a432b872dfa3',
        tag:'pizza'
    }
]
 
export default data;